import React from 'react';
export function GuaranteeSection() {
  return <section className="max-w-2xl mx-auto text-center py-16 px-4" data-id="element-205">
      <div data-id="element-206">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-207">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#00C853] mb-4" data-id="element-208">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="bg-[#000d08] border-2 border-[#00C853] rounded-2xl p-8 mb-6" data-id="element-209">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-210">
            Abrís los tomos. Los usás en el aula.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-211">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#00C853] text-3xl font-black mb-4" data-id="element-212">
            devolución del 100%
          </p>
          <p className="text-white text-xl font-bold" data-id="element-213">
            sin formularios, sin demoras, sin preguntas.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-214">
          Tasa de devoluciones: menos del 1%.
          <br data-id="element-215" />
          <span className="italic mt-2 block" data-id="element-216">
            Eso dice todo lo que necesitás saber.
          </span>
        </p>
      </div>
    </section>;
}